import { render } from "./YoastSeo.vue?vue&type=template&id=15f94e86"
import script from "./YoastSeo.vue?vue&type=script&lang=js"
export * from "./YoastSeo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__